import React, { useState } from "react";
import Navbar from "../layouts/Navbar";
import Footer from "../layouts/Footer";
import OurMission from '../assets/our mission.png'
import OurVision from '../assets/our vision.png'
import HubDirector from '../assets/taiwo.png'
import { Button, Dialog, DialogContent } from "@mui/material";

const About = ()=>{
    const [isOpen, setIsOpen] = useState(false)
    const handleClose = ()=>{
        setIsOpen(false)
    }
    return (
        <div>
            <Navbar />
            <div className="container">
                <div className="row w-100 mx-auto mt-5">
                    <div className="col-md-6 pt-5" data-aos='fade-in'>
                        <p className="fs-5 fw-bold text-yrh pt-lg-5 mt-lg-5">
                            About Us
                        </p>
                        <p className="text-yrh fw-bold-0 text-justify">
                            In May 2022, Taiwo Sokunbi, a Bachelor of Pharmacy (B.Pharm) candidate at Obafemi Awolowo University, founded the Young Researchers’ Hub (YRH) with the sole intention of building a community where students who have an interest in research can come together to learn, collaborate, and network...
                        </p>
                        <Button onClick={()=>setIsOpen(true)} className="rounded-0 bg-yrh text-white fw-bold mb-4">
                            Read More
                        </Button>
                    </div>
                    <div className="col-md-5" data-aos='zoom-in'>
                        <img src={HubDirector} className="img-fluid mt-md-5 mt-xl-0" alt="hub_director" />
                    </div>
                </div>
            </div>
            <div className="bg-yrh p-5">
                <div className="d-flex justify-content-center">
                    <img src={OurMission} className="img-fluid" />
                </div>
                <div className="d-flex justify-content-center">
                    <p className="text-white text-center py-4 col-md-7" data-aos='zoom-in'>
                        To build a community for student researchers where they meet to learn, network and collaborate to contribute to the body of knowledge in their fields of interest and develop witty innovations through research and development.
                    </p>
                </div>
                {/* Mission */}
                {/* Vision */}
                <div className="d-flex justify-content-center pt-4">
                    <img src={OurVision} className="img-fluid" />
                </div>
                <div className="d-flex justify-content-center">
                    <p className="text-white text-center py-4 col-md-7" data-aos='zoom-in'>
                        To be the largest student researchers hub in Africa.
                    </p>
                </div>
            </div>
            <Footer />
            {/* Dialog */}
            <Dialog open={isOpen} maxWidth={'sm'} fullWidth={true} onClose={handleClose} >
                <DialogContent>
                    <p className="fw-bold fs-5 font-poppins">
                        ABOUT YOUNG RESEARCHERS’ HUB, OAU
                    </p>
                    <p className="fs-6 font-poppins text-justify">
                        In an academic environment like a university, the quest to promote academic excellence among
                        undergraduates should not be limited to a perfect cumulative grade point average (CGPA) of 4.0,
                        5.0, or 7.0, as the case may be. All-round academic excellence is possible, which would reflect
                        the perfect CGPA and other metrics that measure excellence in an academic community. These
                        metrics include the quality and, of course, quantity of research outputs, as well as the
                        contribution to the community through the provision of solutions to their immediate problems
                        through innovations. All these are possible. And they are possible through student communities.
                        In May 2022, Taiwo Sokunbi, a Bachelor of Pharmacy (B.Pharm) candidate at Obafemi
                        Awolowo University, founded the Young Researchers’ Hub (YRH) with the sole intention of
                        building a community where students who have an interest in research can come together to
                        learn, collaborate, and network.
                    </p>
                    <p className="fs-6 font-poppins text-justify">
                        Over time, the vision keeps expanding, and the focus of the Hub continues expanding. Now,
                        YRH is the right community or club for student researchers, research enthusiasts, and innovators.
                        The Hub has meticulously created conducive structures that welcome innovative ideas and
                        encourage the development of such to solve problems within and outside the university
                        environment.
                    </p>
                    <p className="fs-6 font-poppins text-justify">
                        Aside from the transformative knowledge acquired by the members through the periodic research
                        training sessions, research mentorship programs, review meetings, and other informative
                        sessions that we can boast of as a community in the first year of establishment, the Hub produced
                        11 research publications in both local and international journals. The members attended scientific
                        conferences and had their abstracts presented to the community of scholars present at the
                        conferences. These are some of the numerous achievements of the Hub within the short time of
                        its establishment.
                    </p>
                    <p className="fs-6 font-poppins text-justify">
                        I encourage every undergraduate whose interest lies in research and development as well as in
                        solving problems to be part of this foremost and fastest-growing student researchers’ community.
                    </p>
                    <p className="my-0 font-poppins text-justify">
                        Taiwo Sokunbi
                    </p>
                    <p className="font-poppins text-justify fw-bold">
                        Founder/Hub Director
                    </p>
                    <p className="font-poppins text-justify fw-bold">
                        YRH
                    </p>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default About